import React from "react";
import PropTypes from "prop-types";

interface ApiProps {
    apiKey: string
}

const CALLBACK_NAME = '__AvianisGoogleMapsApiCallback';

export class Api extends React.Component<ApiProps> {

    static propTypes = {
        apiKey: PropTypes.string.isRequired
    }

    static displayName = "GoogleMaps.Api";

    private addScript = false;

    constructor(props: ApiProps) {
        super(props);
        if (Api.loaded) {
            console.warn("Attempting to load Google Maps API more than once on this page.");
        } else {
            this.addScript = true;
            Api.loaded = new Promise<void>((resolve) => {
                (window as any)[CALLBACK_NAME]= () => {
                    resolve();
                }
            });
        }
    }

    componentDidMount() {
        if (this.addScript) {
            var script = document.createElement("script");
            let keyParam = (this.props.apiKey && `key=${this.props.apiKey}&`) || "";

            script.src = `https://maps.googleapis.com/maps/api/js?${keyParam}callback=${CALLBACK_NAME}`;
            script.async = script.defer = true;

            document.body.appendChild(script);
        }
    }

    public static loaded: Promise<void>;

    render(): null { return null; }
}
